import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="centered-full">
      <div className="card" style={{ maxWidth: 480, textAlign: 'center' }}>
        <h2>Page not found</h2>
        <p className="muted">The page you're looking for doesn't exist.</p>
        <Link className="btn btn-primary" to="/dashboard">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
